import React from 'react';
import './AIList.scss';
import {toast} from "react-toastify";
import AIModal from "../../Modals/AIModal/AIModal";
import i18next from "i18next";
import DynamicList from "../../Lists/DynamicList/DynamicList";
import {NOTIFY_OPTS} from "../../constants/Notifiers";
import {roleForCompany} from "../../Helpers/CompanyHelpers";
import ConfirmationModal from "../../Modals/ConfirmationModal/ConfirmationModal";
import {momentFromDateTime} from "../../Helpers/DateHelpers";
import {errorMessageFromServerError} from "../../Helpers/Helpers";

const notifyAIRemovedError = (aError) => toast(i18next.t('AI_REMOVED_ERROR', {aError:aError}), NOTIFY_OPTS.autoClose);
const notifyAIRemovedSuccess = () => toast(i18next.t('AI_REMOVED'), NOTIFY_OPTS.autoClose);

export default class AIList extends React.Component {
  
  // Init
  
  constructor(props){
    super(props);
    this.state = {
      reload:false,
      aiToAdd:null,
      aiToRemove:null,
      selectedAI:null,
      aiToReplace:null,
      shouldRemove:false
    };
  }
  
  // Render
  
  render(){
    const {client, company, removeAI, removeAIDocument, addAI, addAIDocument, addAIMessage,
      fetchAI, fetchAIs, fetchAIDocuments, fetchAIMessages} = this.props;
    const {reload, aiToAdd, aiToRemove, selectedAI, aiToReplace, shouldRemove} = this.state;
    
    const role = roleForCompany(company);
    const permissions = ['admin', 'admin_level_4'];
    
    let columnsArray = [];
    columnsArray.push({key:'name', columnWeight:1, columnNameKey:'NAME', propertiesArray:['name']});
    columnsArray.push({key:'keyword', columnWeight:1, columnNameKey:'KEYWORD', propertiesArray:['keyword']});
    columnsArray.push({key:'description', columnWeight:3, columnNameKey:'DESCRIPTION', propertiesArray:['description'], valueFormatter:(aDescription) => (aDescription && aDescription.length > 200 ? aDescription.substring(0, 200) + '...' : aDescription)});
    columnsArray.push({key:'updated_at', columnWeight:1, columnNameKey:'SURVEY_DATE', propertiesArray:['updated_at'], valueFormatter:(aDate) => momentFromDateTime(aDate)});
    
    let menuItemsArray = [
      {title:'VIEW', clickAction:(aAI) => this.setState({selectedAI:aAI})},
      {title:'REMOVE', clickAction:(aAI) => this.setState({aiToRemove:aAI}), isValid:(aAI) => aAI && aAI.keyword !== 'default'}
    ];
    
    return (
      <div className="ai-list">
        {permissions.includes(role) && company && company.ai_enabled ?
          <DynamicList id="ai-list"
                       didReload={() => this.setState({reload:false})}
                       menuCancel={() => this.setState({selectedAI:null})}
                       objectToAdd={aiToAdd}
                       fetchObjects={(aLimit, aOffset, aSearchString) => fetchAIs(aLimit, aOffset, aSearchString)}
                       columnsArray={columnsArray}
                       shouldReload={reload}
                       explanationKey='AI_EXPLANATION'
                       menuItemsArray={menuItemsArray}
                       minColumnWidth={100}
                       objectToDelete={shouldRemove ? aiToRemove : undefined}
                       objectToReplace={aiToReplace}
                       addButtonClicked={() => this.setState({selectedAI:{}})}
                       finishedAddingObject={() => this.setState({aiToAdd:null})}
                       finishedDeletingObject={() => this.setState({aiToRemove:null})}
                       responseTotalKeysArray={['data', 'data', 'ai_models', 'total']}
                       finishedReplacingObject={() => this.setState({aiToReplace:null})}
                       responseObjectKeysArray={['data', 'data', 'ai_models', 'ai_models']}
          />
          :
          <div className="no-information-text">
            {i18next.t('AIS_BLOCKED')}
          </div>
        }
        
        <AIModal open={selectedAI !== null}
                 ai={selectedAI}
                 addAI={addAI}
                 close={() => this.setState({selectedAI:null})}
                 client={client}
                 company={company}
                 fetchAI={fetchAI}
                 fetchAIs={fetchAIs}
                 didAddAI={(aAI) => this.setState({selectedAI:aAI, aiToAdd:aAI})}
                 didUpdateAI={(aAI) => this.setState({selectedAI:{...aAI}, aiToReplace:aAI})}
                 addAIMessage={addAIMessage}
                 addAIDocument={addAIDocument}
                 fetchAIMessages={fetchAIMessages}
                 fetchAIDocuments={fetchAIDocuments}
                 removeAIDocument={removeAIDocument}
        />
        
        <ConfirmationModal title={i18next.t('REMOVE_AI')}
                           isOpen={aiToRemove !== null}
                           reject={() => this.setState({scheduleToRemove:null})}
                           confirm={() => {
                             removeAI(aiToRemove ? aiToRemove.id : undefined).then((newResult) => {
                               notifyAIRemovedSuccess();
                               this.setState({shouldRemove:true});
                             }, (newError) => {
                               notifyAIRemovedError(errorMessageFromServerError(newError));
                               this.setState({aiToRemove:null});
                             })
                           }}
                           description={i18next.t('REMOVE_AI_DESCRIPTION', {aName:aiToRemove ? aiToRemove.name : ''})}
        />
      </div>
    )
  }
}
